/**
* Created by kongwm.kong on 2017/7/21.
*/
<template>
    <div class="layout_n">
        <div class="agree_page_wrap">
            <div class="bigTitle">金斧子服务条款</div>
            <div class="agree-item">
                <div class="title">一、接受条款</div>
                <p>
                  金斧子网根据以下服务条款为您提供服务。您在使用金斧子网提供的服务之前，请仔细阅读本服务条款。金斧子网有权在必要时修改本服务条款。
                  服务条款一旦发生变动，将会在重要页面上提示。如果您不同意所改动的内容，您可以主动注销您的用户帐号或者提请金斧子网工作人员为您注销。
                  如果您继续使用金斧子网的服务，则视为接受服务条款的变动。金斧子网保留随时修改或中断服务而不需知照您的权利。金斧子网行使修改或中断服务的权利，不需对您或第三方负责。
                  同时，您在金斧子网发表合法言论、上传原创作品，视为您免费授予金斧子对您言论、作品的使用权，该授权无地域、期限、方式限制，金斧子可在现行法律范围内就该作品进行使用，
                  包括但不限于复制、发行、出租、展览、表演、放映、广播、信息网络传播、摄制、改编、翻译、汇编等。
                </p>
            </div>
            <div class="agree-item">
                <div class="title">二、服务内容</div>
                <p>
                  金斧子网目前向用户提供如下服务：阅读金斧子网资讯，获取金斧子网销售的基金等金融产品信息，咨询服务，在金斧子网发表合法言论、上传原创作品等。
                </p>
            </div>
            <div class="agree-item">
                <div class="title">三、特别提醒条款</div>
                <p>
                  需要特别提醒您的是金斧子网为一家综合网络理财平台，您注册为金斧子网用户，根据《私募投资基金募集行为管理办法》需要您符合“合格投资者”标准，
                  即具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100 万元的自然人和法人或其他组织：
                  （1）具有2年以上投资经历，且满足以下条件之一：家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或近3年本人年均收入不低于40万元；
                  （2）最近1年末净资产不低于1000万元的法人单位；
                  （3）金融管理部门视为合规投资者的其他情形。
                  您同意本服务协议，并注册成为金斧子网的合格投资者，方可获得金斧子网私募投资基金产品宣传推介服务。
                </p>
            </div>
            <div class="agree-item">
                <div class="title">四、遵守法律</div>
                <p>
                  您同意遵守中华人民共和国相关法律法规的所有规定，并对以任何方式使用您的密码和您的账户使用本服务的任何行为及其结果承担全部责任。
                  如您的行为违反国家法律和法规的任何规定，有可能构成犯罪，将被追究刑事责任，并由您承担全部法律责任。
                  同时，如果金斧子网有理由认为您的任何行为，包括但不限于您的任何言论和其他行为违反或可能违反国家法律和法规的任何规定，金斧子网可在任何时候不经任何事先通知终止向您提供服务。
                </p>
            </div>
          <div class="agree-item">
            <div class="title">五、帐号管理</div>
            <p>
              您一旦注册成功，成为金斧子网的合法用户，将得到一个密码和用户名，您将对用户名和密码安全负全部责任，而且对以您用户名进行的所有活动和事件负全部责任，您可以随时改变您的密码。
              若您发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通知金斧子网管理员；您必须提供真实的个人资料，并且在发生变动时及时地更新您在金斧子网中的个人资料；
              您应当同意“金斧子网”通过电子邮件不定期向您发送网站更新信息、赞助商广告或其他相关的服务信息。
            </p>
          </div>
          <div class="agree-item">
            <div class="title">六、用户行为</div>
            <p>
              您同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为：<br>
              1、发布或以其他方式传送含有下列内容之一的信息：<br>
              (1) 反对宪法所确定的基本原则的。<br>
              (2) 危害国家安全，泄露国家秘密，破坏国家统一的。<br>
              (3) 颠覆国家政权，推翻社会主义制度的。<br>
              (4) 损害国家荣誉和利益的。<br>
              (5) 煽动民族仇恨、民族歧视，破坏民族团结的。<br>
              (6) 破坏国家宗教政策，宣扬邪教和封建迷信的。<br>
              (7) 散布谣言，捏造或歪曲事实，扰乱社会秩序，破坏社会稳定的。<br>
              (8) 散布迷信、淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。<br>
              (9) 侮辱或者诽谤他人，侵害他人合法权益的。<br>
              (10) 进行商业广告行为的。<br>
              (11) 干扰或混乱网络服务，不遵守所有使用网络服务的网络协议、规定、程序和惯例的。<br>
              (12) 含有法律、行政法规禁止的其他内容的。<br>
              2、您在使用金斧子网时，禁止进行以下活动，：<br>
              (1) 直接或间接在“金斧子网”宣传其它竞争网站或为其它类似竞争网站做广告。<br>
              (2) 扰乱“金斧子网”社区的秩序，在社区中发布与主题无关的广告或无意义的信息。<br>
              (3) 大量发布相同的问题或回答。<br>
              (4) 其它可能对“金斧子网”不利的行为或违反任何中华人民共和国法律的行为。
            </p>
          </div>
            <div class="agree-item">
                <div class="title">七、服务终止</div>
                <p>
                  金斧子网可随时根据实际情况中断一项或多项网络服务。金斧子网不需要对您或第三方负责而可以随时中断服务。若您对后来的条款修改有异议，或对金斧子网的服务不满，可以行使如下权利：<br>
                  (1) 停止使用金斧子网的服务。<br>
                  (2) 提前结束金斧子网的服务。<br>
                  结束服务后，您使用网络服务的权利马上终止。即时起，您没有权利，金斧子网也没有义务传送任何未处理的信息或未完成的服务给您或第三方。
                </p>
            </div>
            <div class="agree-item">
                <div class="title">八、免责声明</div>
                <p>
                  1、金斧子网不担保以下事宜：<br>
                  (1) 您个人对网络服务的使用承担风险，金斧子网对此不作任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。<br>
                  (2) 金斧子网不担保服务一定能满足您的要求，也不担保服务不会受中断，对服务的及时性、安全性、出错发生都不作担保。<br>
                  (3) 金斧子网对在金斧子网上得到的任何商品购物服务或交易进程，不作担保。<br>
                  2、金斧子网对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害包括但不限于：<br>
                  (1) 不正当使用网络服务；<br>
                  (2) 在网上购买商品或进行同类型服务；<br>
                  (3) 在网上进行交易；<br>
                  (4) 非法使用网络服务或用户传送的信息有所变动。<br>
                  这些行为都有可能会导致金斧子网的形象受损，金斧子网保留自己遭受损害向用户追偿的权利。<br>
                  3、金斧子网不对您所发布信息的删除或储存失败负责。金斧子网若认定您的行为违背金斧子网服务条款的内容和精神的要求，金斧子网有权中断对您提供的服务。
                </p>
            </div>
            <div class="agree-item">
                <div class="title">九、其他</div>
                <p>
                  1、金斧子网服务条款适用中华人民共和国法律解释。如发生金斧子网服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对用户产生法律效力和影响。<br>
                  2、与本服务条款发生的争议，由双方友好协商解决，若协商不能解决的，双方均同意将争议提交给华南国际经济贸易仲裁委员会按其届时有效的仲裁规则仲裁，仲裁地在深圳。
                </p>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data(){
            return {

            }
        },
        created(){
            this.$router.push('/agree');
        }

    }
</script>
<style lang="scss" type="text/scss" scoped>
    .layout_n{
        margin-top:30px;
        margin-bottom: 50px;
    }
    .agree_page_wrap{
        @include bgff;
        padding: 30px 60px 50px;
        /*border: 1px solid #dfdfdf;*/
        line-height: 2;
        .bigTitle{
            text-align: center;
            font-size: 24px;
            font-weight: bold;
        }
        .agree-item{
            margin-top:30px;
            .title{
                margin-top: 10px;
                padding: 5px 0;
                font-size: 18px;
                font-weight: bold;
            }
            p{
                padding-left: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/user/agree.vue